import { tv, type VariantProps } from "tailwind-variants";

export const spinnerVariant = tv({
  slots: {
    base: ["animate-spin", "size-4", "text-text-neutral-inverse"],
  },
  variants: {},
  defaultVariants: {},
});

export type SpinnerVariantProps = VariantProps<typeof spinnerVariant>;
export type SpinnerReturnVariantProps = ReturnType<typeof spinnerVariant>;
